// extracted by mini-css-extract-plugin
module.exports = {"numberFormat":"_2M_-AFTRPXDcjmVSZF1yPA"};